import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.page.html',
  styleUrls: ['./privacy-policy.page.scss'],
})
export class PrivacyPolicyPage implements OnInit {
  googleDocUrl: string = "https://docs.google.com/document/d/e/2PACX-1vRZZIRfXWTB6zfqgmTkXLN1Otbo2tmD74BCdXBm3gd_ELJyPyeBsnomhGRxJO0NFQ/pub?embedded=true";
 
  constructor( public modalCtrl:ModalController) {
  }

  ngOnInit() {
  }

  async close(){
    await this.modalCtrl.dismiss()
  }

}
